import Card from "components/card";
import React, { useEffect, useState } from "react";
import InputField from "components/fields/InputField";
import CustomButton from "components/button/custom_button";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { ESService } from "services/esService";
import { currentUser } from "services/users/authSlice";
import ApiList from "services/apiList";
import { MdDelete } from "react-icons/md";
import Modal from "components/modal";
import Select from "components/select";
import Badge from "components/badge";
const CourseDetail = () => {
  const navigate = useNavigate();
  var user = useSelector(currentUser);
  const [values, setValues] = useState({ group: "", description: "" });
  const location = useLocation();
  const [showModal, setShowModal] = useState(false);

  const [number, setNumber] = useState(0);
  const numbers = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];

  const [teacher, setTeacher] = useState("");
  const [teachers, setTeachers] = useState([]);
  const [classroom, setClassroom] = useState(-1);
  const [classrooms, setClassrooms] = useState([]);

  const [classStudents, setClassStudents] = useState([]);
  const [students, setStudents] = useState([]);

  const inputs = [
    {
      id: "c1",
      name: "group",
      type: "text",
      placeholder: "e.g. а б в г д",
      errorMessage:
        "Бүлэг нь кирил үсгээс тогтох бөгөөд 1 тэмдэгт байна. Мөн тусгай тэмдэгт орох ёсгүй!",
      label: "Бүлэг",
      pattern:
        "^[абвгдеёжзийклмноөпрстуүфхцчшщъыьэюяАБВГДЕЁЖЗИЙКЛМНОӨПРСТУҮФХЦЧШЩЪЫЬЭЮЯ]{1}$",
      required: true,
    },
    {
      id: "c2",
      name: "description",
      type: "text",
      placeholder: "e.g. тайлбар",
      errorMessage:
        "Тайлбар 1-с дээш тэмдэгтээс бүрдэх бөгөөд ямар нэгэн тусгай тэмдэгт оруулах ёсгүй!",
      label: "Тайлбар",
      pattern: "^.+$",
      required: false,
    },
  ];

  useEffect(() => {
    const getClassrooms = () => {
      const token = user.token;
      const es = new ESService(token);
      es.get(ApiList.roomUrl).then((json) => {
        if (json["status"]) {
          setClassrooms(json["data"]);
          // EDIT UYED TUHAIN HICHEELIIN SONGOGDSON ROOM IIG ONOOJ BAIGAA HESEG
          if (location.state.type === "edit") {
            setClassroom(
              location.state.data.classroom === null
                ? -1
                : location.state.data.classroom.id
            );
          }
        }
      });
    };

    const getClassStudents = (id) => {
      const token = user.token;
      const es = new ESService(token);
      es.get(ApiList.courseStudentsUrl, "id=" + id).then((json) => {
        if (json["status"]) {
          var selectedStudents = [];
          selectedStudents = json["data"]["students"].map((row, index) => {
            return {
              id: row.id,
              name:
                row.lastname[0].toUpperCase() +
                ". " +
                row.firstname +
                " - " +
                row.username,
            };
          });
          setClassStudents(selectedStudents);
        }
      });
    };
    const getTeachers = () => {
      const token = user.token;
      const es = new ESService(token);
      es.get(ApiList.userUrl, "role=teachers").then((json) => {
        if (json["status"]) {
          setTeachers(json["data"]);
          // EDIT UYED TUHAIN HICHEELIIN SONGOGDSON ROOM IIG ONOOJ BAIGAA HESEG
          if (location.state.type === "edit") {
            setTeacher(location.state.data.teacher.id);
          }
        }
      });
    };

    const getStudents = () => {
      const token = user.token;
      const es = new ESService(token);
      es.get(ApiList.userUrl, "role=students").then((json) => {
        if (json["status"]) {
          setStudents(json["data"]);
          // EDIT UYED TUHAIN HICHEELIIN SONGOGDSON ROOM IIG ONOOJ BAIGAA HESEG
        }
      });
    };
    if (location.state.type === "edit") {
      setValues(location.state.data);
      setNumber(location.state.data.number);
      getClassStudents(location.state.data.id);
    }
    getTeachers();
    getStudents();
    getClassrooms();
  }, [location.state, user]);
  const onChange = (e) => {
    setValues({ ...values, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    if (!e.preventDefault()) {
      const token = user.token;
      const es = new ESService(token);

      var selectedStudents = [];
      for (let i = 0; i < classStudents.length; i++) {
        selectedStudents.push(classStudents[i].id);
      }

      const data = {
        number: number,
        group: values["group"],
        description: values["description"],
        teacher: teacher,
        students: selectedStudents,
        classroom: parseInt(classroom),
      };

      if (location.state.type === "edit") {
        es.put(ApiList.courseUrl + values["id"] + "/", data).then((json) => {
          if (json["status"]) {
            navigate("/admin/course");
          }
        });
      } else {
        es.post(ApiList.courseUrl, data).then((json) => {
          if (json["status"]) {
            navigate("/admin/course");
          }
        });
      }
    }
  };

  const handleDelete = (e) => {
    const token = user.token;
    const es = new ESService(token);
    es.delete(ApiList.courseUrl + values["id"] + "/", {}).then((json) => {
      if (json["status"]) {
        navigate("/admin/course");
      }
    });
  };

  const addStudentToClass = (e) => {
    e.preventDefault();
    setClassStudents((selectedRooms) => {
      var selectedStudents = [...selectedRooms];
      const isAdded = selectedStudents.findIndex(
        (item) => item.id.toString() === e.target.value.toString()
      );
      if (isAdded === -1) {
        selectedStudents.push({
          id: e.target.value,
          name: e.nativeEvent.target[e.nativeEvent.target.selectedIndex].text,
        });
      }
      return selectedStudents;
    });
  };

  const removeStudentFromClass = (index) => {
    setClassStudents((selectedRooms) => {
      var selectedStudents = [...selectedRooms];
      selectedStudents.splice(index, 1);

      return selectedStudents;
    });
  };

  return (
    <Card extra={"mt-4 w-full bg-white p-5"}>
      <header className="relative flex items-center justify-end pt-4 lg:pr-20">
        <button
          className={`rounded-lg bg-lightPrimary p-2 text-brand-500 !transition !duration-200 hover:bg-gray-100 active:bg-gray-200 dark:bg-navy-700 dark:text-white dark:hover:bg-white/20 dark:active:bg-white/10  ${
            location.state.type === "edit" ? "block" : "pt-30 hidden"
          }`}
          onClick={() => setShowModal(true)}
        >
          <MdDelete className="h-6 w-6 fill-red-600" />
        </button>
      </header>

      <div className=" justify-start gap-5 lg:flex lg:px-20 lg:pb-20 ">
        <form onSubmit={handleSubmit} className="w-4/12	">
          <Select
            id="number"
            value={number}
            required={true}
            label="Анги"
            defaultText="Анги сонгоно уу."
            onChange={(selected) => {
              setNumber(selected.target.value);
            }}
            children={numbers.map((row, index) => {
              return (
                <option key={index} value={row}>
                  {row}
                </option>
              );
            })}
          />

          {/* USER INPUTS  */}
          {inputs.map((input) => (
            <InputField
              key={"key" + input.id}
              id={input.id}
              className="lg:w-100"
              {...input}
              value={values[input.name]}
              onChange={onChange}
            />
          ))}
          <div className="mt-2"></div>
          <Select
            id="teacher"
            value={teacher}
            required={true}
            label="Анги даасан багш"
            defaultText="Анги даасан багш сонгоно уу."
            onChange={(selected) => {
              setTeacher(selected.target.value);
            }}
            children={teachers.map((row, index) => {
              return (
                <option key={index} value={row.id}>
                  {row.lastname[0].toUpperCase() +
                    ". " +
                    row.firstname +
                    " - " +
                    row.username}
                </option>
              );
            })}
          />
          <Select
            id="classroom"
            value={classroom}
            required={true}
            label="Үндсэн анги, танхим"
            defaultText="Үндсэн анги, танхим сонгоно уу."
            onChange={(selected) => {
              setClassroom(selected.target.value);
            }}
            children={classrooms.map((row, index) => {
              return (
                <option key={index} value={row.id}>
                  {row.building.name} - {row.number}
                </option>
              );
            })}
          />
          <label
            htmlFor={"student_course_label"}
            className="ml-3 text-sm font-bold text-navy-700 dark:text-white"
          >
            Cурагч нэмэх
          </label>
          <br />
          {classStudents.map((row, index) => {
            return (
              <Badge
                key={"student_badge" + index}
                index={index}
                text={row.name}
                remove={removeStudentFromClass}
              />
            );
          })}
          <Select
            id="students"
            required={false}
            value=""
            defaultText="Сурагч сонгоно уу."
            className="mt-2"
            onChange={addStudentToClass}
            children={students.map((row, index) => {
              return (
                <option key={index} value={row.id}>
                  {row.lastname[0].toUpperCase() +
                    ". " +
                    row.firstname +
                    " - " +
                    row.username}
                </option>
              );
            })}
          />

          <CustomButton text="Хадгалах" type="submit" className="mr-3" />
          <CustomButton
            onClick={() => {
              navigate("/admin/course");
            }}
            text="Буцах"
            isBack={true}
          />
        </form>
        {showModal ? (
          <Modal
            handleSubmit={handleDelete}
            setShowModal={setShowModal}
            child={
              <p className="text-xl text-navy-700 dark:text-white">
                Та "{values["name"]}"-ыг устгахдаа итгэлтэй байна уу? Дараахтай
                холбоотой бүх зүйл устаж болзошгүй
              </p>
            }
            title="Устгах"
          />
        ) : null}
      </div>
    </Card>
  );
};

export default CourseDetail;
